<template>
  <div>
    <section class="hero is-info is-medium is-bold">
      <headerbar></headerbar>
     </section>

    <vue-simple-spinner id="spinner" style="padding: 100px"></vue-simple-spinner>

    <section id="main_content" class="section">
    <div class="container">
      <h2 class="title">{{pageTitle}} {{categories['.value']}}</h2>
      <div class="filters">
        <div>
          <!-- Categories -->
          <dropdown :options="booksList" :selectedElement="params.category" />
        </div>
        <hr class="navbar-divider" />

      </div>

      <div class="columns is-desktop" v-for="n in (Math.ceil(filteredBooks.length/3))" v-bind:key="n">
        <div class="column is-4" v-if="featured" v-for="book in filteredBooks.slice(3*(n-1),3*n)" :key="book.title">
          <div class="columns is-mobile">
            <div class="column is-4">
              <figure class="image is-2by3">
              <a v-bind:href="'/titulo/'+ book['.key']"><img class="book-cover" :src="book.cover"></a>
              </figure>
            </div>
            <div class="column">
              <h1 class="title is-5"><a v-bind:href="'/titulo/'+ book['.key']">{{book.title}}</a></h1>
              <h2 class="subtitle is-6" v-if="book.authors"><em>de</em> <span v-if="book.authors" v-for="auth in book.authors" v-bind:key="auth">{{auth}}<br></span></h2>
              <!--h2 class="is-6" v-if="book.price_paper">{{book.price_paper}}€</h2-->
              <!--a v-bind:href="'/titulo/' + book['.key'] + '?show_download=true'"><span class="tag is-ebook"><i class="fa fa-file-text" aria-hidden="true"></i>&nbsp;Ebook grátis</span></a-->
              <div class="control">
                <div class="tags has-addons">
                  <span class="tag is-ebook-dark"><i class="fa fa-file-text" aria-hidden="true"></i>&nbsp;&nbsp;eBook</span>
                  <span class="tag is-ebook">Grátis</span>
                </div>
                <div v-if="book.price_paper" class="tags has-addons">
                  <span class="tag is-book-dark"><i class="fa fa-book" aria-hidden="true"></i>&nbsp;&nbsp;Livro *</span>
                  <span class="tag is-book">5€</span>
                </div>
                <p v-if="book.price_paper" class="is-size-7">* impressão a pedido.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
     <hr class="hr" style="margin-bottom: 0;">
    </div>
    </section>

    <footerbar></footerbar>

     <div id="modal-ter" class="modal">
       <div class="modal-background"></div>
       <div class="modal-card">
         <header class="modal-card-head">
           <p class="modal-card-title">Modal title</p>
           <button class="delete" aria-label="close"></button>
         </header>
         <section class="modal-card-body">
           <!-- Content ... -->
         </section>
         <footer class="modal-card-foot">
           <button class="button is-success">Save changes</button>
           <button class="button">Cancel</button>
         </footer>
       </div>
     </div>
  </div>
</template>

<script>
import { settingsRef, booksRef, categoriesRef, featuredRef, navRef, mediaRef } from '../firebase_config'
import bookFilters from '@/mixins/bookFilters'
// import Utils from '@/mixins/utils'
import Spinner from 'vue-simple-spinner'
import dropdown from '@/components/shared/Dropdown'
import Header from './Header'
import Foot from './Foot'
export default {
  name: 'home',
  components: {
    'headerbar': Header,
    'footerbar': Foot,
    dropdown,
    'vue-simple-spinner': Spinner
  },
  data () {
    var self = this
    featuredRef.once('value').then(function (questionsSnapshot) {
      for (var key in questionsSnapshot.val()) {
        booksRef.child(key).once('value').then(function (booksSnapshot) {
          var book = booksSnapshot.val()
          book['.key'] = booksSnapshot.key
          self.featured.push(book)
        })
      }
    })
    return {
      'pageTitle': (this.$route.params.key ? '' : 'Títulos'),
      'featured': [] // return empty array, will be populated after featuredRef loads
    }
  },
  mixins: [bookFilters],
  firebase () {
    var catRef = categoriesRef
    if (this.$route.params.key) {
      catRef = categoriesRef.child(this.$route.params.key)
    }
    return {
      // load settings as object instead of array (default)
      settings: {
        source: settingsRef,
        asObject: true
      },
      books: {
        source: booksRef,
        asObject: false
      },
      feat: {
        source: featuredRef,
        asObject: false
      },
      categories: {
        source: catRef,
        asObject: true
      },
      nav: {
        source: navRef
      },
      media: {
        source: mediaRef
      }
    }
  },
  beforeMount: function () {
    // this.selectedOption = this.$route.params.key
    // this.params.category.label = 'Conto'
    this.selectedState = 'published'
  },
  updated: function () {
    var elem = document.querySelector('#spinner')
    if (elem) {
      elem.parentNode.removeChild(elem)
      document.querySelector('#main_content').style.display = 'block'
    }
    // print titles list
    var string = ''
    this.filteredBooks.forEach(function (index) {
      string += '\'/titulo/' + index['.key'] + '/\',\n'
    })
    console.log(string)
  },
  mounted: function () {
    // force cat
    if (this.$route.params.key) {
      self.page_title = 'A'
      this.params.category.id = this.$route.params.key
      this.params.category.label = this.params.category.id
      var filters = document.querySelector('.filters')
      filters.style.display = 'none'
    }
  },
  computed: {
    loadLogo () {
      var i = this.media.length
      var url = null
      while (i--) {
        if (this.media[i].name === 'WebsiteLogo') {
          url = this.media[i].src
        }
      }
      return url
    }
  }
}

</script>

<style lang="scss" scoped>
.book-cover {
  -webkit-box-shadow: 0 0 5px rgba(0,0,0,0.6);
  -moz-box-shadow: 0 0 5px rgba(0,0,0,0.6);
  box-shadow: 0 0 5px rgba(0,0,0,0.6);
}
.filters {
    padding-bottom: 15px;
    padding-top: 0px;
}

</style>



// WEBPACK FOOTER //
// src/components/Titles.vue